<template>
  <div class="glaxi-footer__newsletter">
    <h4 class="glaxi-footer__newsletter__title" v-html="$t('forms.stayTuned')" />
    <form 
      action="https://glaxipane.us19.list-manage.com/subscribe/post?u=5d845b52ed0da3ba0d194de0b&amp;id=975179c17e" 
      method="post" 
      id="mc-embedded-subscribe-form" 
      name="mc-embedded-subscribe-form" 
      class="validate c-form-newsletter" 
      target="_blank"
      @submit="checkForm"
      novalidate>
      
      <input 
        v-model="email"
        :class="{'error': erroreEmail}"
        type="email" 
        name="EMAIL" 
        :placeholder="$t('forms.emailAddress')"
        class="required email"
        id="mce-EMAIL">
      
      <button 
        class="c-btn"
        title="Subscribe"
        name="subscribe"
        id="mc-embedded-subscribe">
        <span>{{ $t('forms.subscribe') }}</span>
      </button>

      <input
        type="hidden"
        v-model="lang"
        name="LANG"
        class="required"
        id="mce-LANG">

      <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_5d845b52ed0da3ba0d194de0b_975179c17e" tabindex="-1" value=""></div>

      <div class="glaxi-footer__newsletter__checkbox">
        <p>{{ $t('forms.articles') }}</p>
        <div>

          <input 
            v-model="privacy" 
            :class="{'error': errorePrivacy}" 
            id="privacy" 
            class="checkbox-custom" 
            name="checkbox-2" 
            type="checkbox">

          <label for="privacy" class="checkbox-custom-label"> {{ $t('forms.privacyTextFormNewsletter') }} <router-link :to="{ name: `${lang}.single-page`, params: { slug: 'privacy-policy' } }">Privacy Policy</router-link>.</label>
        </div>
        <div id="mce-responses" class="clear">
          <div class="response" id="mce-error-response" style="display:none"></div>
          <div class="response" id="mce-success-response" style="display:none"></div>
        </div>
      </div>
    </form>

  </div>
</template>

<script>

import { mapGetters } from 'vuex'
export default {
  name: 'GlaxiFooterNewsletter',
  data: () => ({
    privacy: false,
    email: '',
    errorePrivacy: false,
    erroreEmail: false
  }),
  computed: {
    ...mapGetters([
      'lang'
    ])
  },
  methods:{
    checkForm(e){
      var errori = false
      this.errorePrivacy = false
      this.erroreEmail = false
      if (!this.privacy) {
        this.errorePrivacy = true
        errori = true
      }
      if (!this.email || !this.validEmail(this.email)) {
        this.erroreEmail = true
        errori = true
      }
      if (!errori) return
      e.preventDefault()
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>

<style lang="scss">
  @import "./newsletter.scss";
</style>
